import { render } from "./MfDetailRow.vue?vue&type=template&id=362dec56"
import script from "./MfDetailRow.vue?vue&type=script&lang=js"
export * from "./MfDetailRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__